module.exports = __webpack_public_path__ + "static/media/WorkHistoryTimeline.04181c62.svg";